import { render, staticRenderFns } from "./timeLimitList.vue?vue&type=template&id=5f662813&scoped=true"
import script from "./timeLimitList.vue?vue&type=script&lang=js"
export * from "./timeLimitList.vue?vue&type=script&lang=js"
import style0 from "./timeLimitList.vue?vue&type=style&index=0&id=5f662813&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f662813",
  null
  
)

export default component.exports